import { render, staticRenderFns } from "./testiCarrelloPolize.vue?vue&type=template&id=65ed9038&"
import script from "./testiCarrelloPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./testiCarrelloPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports